export const ParentCategoryState = {
    data: {
        category_id: '',
        selected_category: '',
        unmapped_categories:[]
    }
}